export const groupBy = <T = unknown>(
  array: T[],
  key: (item: T) => string,
): Record<string, T[]> => {
  const map: Record<string, T[]> = {};

  for (const item of array) {
    const groupKey = key(item);
    if (!map[groupKey]) {
      map[groupKey] = [];
    }
    map[groupKey].push(item);
  }

  return map;
};
